import Axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  MixedWidget1,
  StatsWidget11,
  StatsWidget12,
} from "../../../_metronic/_partials/widgets";
import { MixedWidget2 } from "../../../_metronic/_partials/widgets/mixed/MixedWidget2";
import { StatsWidget13 } from "../../../_metronic/_partials/widgets/stats/StatsWidget13";

export default function WholesaleDashboard() {
  const {
    user: {
      accessToken,
      refreshToken,
      user: { user_role_id },
    },
  } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState("");

  const getChartData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/dashboard/orderAmountAndCountLastWeekForAllType`,
      {
        type: "Wholesale",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setChartData(data.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getChartData();
  }, []);
  return (
    <Fragment>
      {loading ? (
        <>Loading...</>
      ) : (
        user_role_id != 3 && (
          <div className="row">
            <div className="col-lg-12">
              <MixedWidget2 className="card-stretch gutter-b" />
            </div>

            <div className="col-lg-6 col-xxl-6">
              <StatsWidget11
                className="card-stretch gutter-b"
                data={chartData}
              />
            </div>
            <div className="col-lg-6 col-xxl-6">
              <StatsWidget12
                className="card-stretch gutter-b"
                data={chartData}
              />
            </div>
            <div className="col-12 col-lg-12 col-xxl-12">
              <StatsWidget13
                className="card-stretch gutter-b"
                data={chartData}
              />
            </div>
          </div>
        )
      )}
    </Fragment>
  );
}
